import { SxProps, Theme } from '@mui/material';

export const SECTION_ACCORDION_SX: SxProps<Theme> = {
  m: 0,
  mb: 1,
  boxShadow: 'unset',
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  borderRadius: 0,
  '&:before': { opacity: 0 },
  '&.Mui-expanded': {
    m: 0,
    mb: 1,
  },
  '&.Mui-expanded:before': { opacity: 0 },
  '& .MuiAccordionSummary-root': {
    px: 2,
    py: 0,
    minHeight: '48px',
    '&.Mui-expanded': {
      minHeight: '48px',
      px: 2,
      py: 0,
    },
  },
  '& .MuiAccordionSummary-content': {
    m: '12px 0',
    '&.Mui-expanded': {
      m: '12px 0',
    },
  },
};

export const SECTION_SUMMARY_SX: SxProps<Theme> = {
  backgroundColor: 'grey.100',
  px: 2,
  py: 0,
  minWidth: 0,
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    minWidth: 0,
  },
};

export const SECTION_TITLE_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  overflowWrap: 'anywhere',
};

export const SECTION_NUMBER_SX: SxProps<Theme> = {
  mr: '14px',
  minWidth: 'fit-content',
  whiteSpace: 'nowrap',
  color: 'text.primary',
};

export const SECTION_DETAILS_SX: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  p: 2,
};

export const TREE_CHILDREN_SX: SxProps<Theme> = {
  mt: 2,
};
